export default __webpack_public_path__ + "static/media/404_bg_desktop.2301a41d.png";